import { entity } from "./Connection"

// Selected-ship Settings arrive with `ships.get`; there is no separate initial
// per-ship Settings request. The API orders duplicate types newest-first; keep
// that invariant after live inserts so acquisition can consistently take the first.
export const SettingsEntity = entity("Settings", {
  providedBy: "Ship",
  sort: (a, b) => b.updatedAt.localeCompare(a.updatedAt) || b.id - a.id,
});
